export default {
  COUNTRY_CODE: 'mx',

  /** External URLs */
  USER_ACCOUNT_URL: 'https://rebajatuscuentas.com/mx/usuario',
  WEBSITE_URL: 'https://rebajatuscuentas.com/mx',
  BLOG_URL: 'https://rebajatuscuentas.com/mx/blog',

  CURRENCIES: [
    { title: 'Pesos', value: 4 },
  ],

  INSURANCE_TYPES: [
    { text: 'Solo', value: 2 },
    { text: 'Con mi pareja', value: 1 },
  ],

  /* Flow */
  STEPS: () => require('./steps').default,

  /** Accounting */
  MONEY_SYMBOL: process.env.VUE_APP_MONEY_SYMBOL || '$',
  MONEY_FORMAT: process.env.VUE_APP_MONEY_FORMAT || '%s %v',
  NUMBER_DECIMAL: process.env.VUE_APP_NUMBER_DECIMAL || ',',
  NUMBER_THOUSAND: process.env.VUE_APP_NUMBER_THOUSAND || '.',
};
